import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { EventService } from './demo/service/event.service';
import { IconService } from './demo/service/icon.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { AuthService } from './demo/service/auth.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './demo/interceptors/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';



@NgModule({
    declarations: [AppComponent],
    imports: [AppRoutingModule, AppLayoutModule, NgxExtendedPdfViewerModule, ButtonModule, FormsModule, DropdownModule, BrowserAnimationsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        // { provide: LocationStrategy, useClass: PathLocationStrategy },
        AuthService,{provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        EventService, IconService,
        ConfirmationService, MessageService
    ],
    bootstrap: [AppComponent],
    exports:[CommonModule,ButtonModule]

})
export class AppModule { }
